import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'intro',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule)
  },
  {
    path: 'intro',
    loadChildren: () => import('./intro/intro.module').then(m => m.IntroPageModule)
  },
  {
    path: 'authphone',
    loadChildren: () => import('./authphone/authphone.module').then(m => m.AuthphonePageModule)
  },
  {
    path: 'authconfirm',
    loadChildren: () => import('./authconfirm/authconfirm.module').then(m => m.AuthconfirmPageModule)
  },
  {
    path: 'firstsetup',
    loadChildren: () => import('./firstsetup/firstsetup.module').then( m => m.FirstsetupPageModule)
  },
  {
    path: 'emailconfirm',
    loadChildren: () => import('./emailconfirm/emailconfirm.module').then( m => m.EmailconfirmPageModule)
  },
  {
    path: 'shoptype',
    loadChildren: () => import('./funnel/shop-type/shop-type.module').then( m => m.ShopTypePageModule)
  },
  {
    path: 'mode',
    loadChildren: () => import('./funnel/mode/mode.module').then( m => m.ModePageModule)
  },
  {
    path: 'time',
    loadChildren: () => import('./funnel/time/time.module').then( m => m.TimePageModule)
  },
  {
    path: 'address-search',
    loadChildren: () => import('./funnel/address-search/address-search.module').then( m => m.AddressSearchPageModule)
  },
  {
    path: 'address-position',
    loadChildren: () => import('./funnel/address-position/address-position.module').then( m => m.AddressPositionPageModule)
  },
  {
    path: 'address-type',
    loadChildren: () => import('./funnel/address-type/address-type.module').then( m => m.AddressTypePageModule)
  },
  {
    path: 'account',
    loadChildren: () => import('./account/account.module').then( m => m.AccountPageModule)
  },
  {
    path: 'update',
    loadChildren: () => import('./update/update.module').then( m => m.UpdatePageModule)
  },
  {
    path: 'updateconfirm',
    loadChildren: () => import('./updateconfirm/updateconfirm.module').then( m => m.UpdateconfirmPageModule)
  },
  {
    path: 'setting',
    loadChildren: () => import('./setting/setting.module').then( m => m.SettingPageModule)
  },
  {
    path: 'payment',
    loadChildren: () => import('./payment/payment.module').then( m => m.PaymentPageModule)
  },
  {
    path: 'bottompopup',
    loadChildren: () => import('./bottompopup/bottompopup.module').then( m => m.BottompopupPageModule)
  },
  {
    path: 'bottom-order-detail',
    loadChildren: () => import('./orderdetail/bottom-order-detail/bottom-order-detail.module').then( m => m.BottomOrderDetailPageModule)
  },
  {
    path: 'shopdetail',
    loadChildren: () => import('./shopdetail/shopdetail.module').then( m => m.ShopdetailPageModule)
  },
  {
    path: 'productdetail',
    loadChildren: () => import('./productdetail/productdetail.module').then( m => m.ProductdetailPageModule)
  },
  {
    path: 'restaurantdetail',
    loadChildren: () => import('./restaurantdetail/restaurantdetail.module').then( m => m.RestaurantdetailPageModule)
  },
  {
    path: 'shelfdetail',
    loadChildren: () => import('./shelfdetail/shelfdetail.module').then( m => m.ShelfdetailPageModule)
  },
  {
    path: 'cart',
    loadChildren: () => import('./cart/cart.module').then( m => m.CartPageModule)
  },
  {
    path: 'chat',
    loadChildren: () => import('./chat/chat.module').then( m => m.ChatPageModule)
  },
  {
    path: 'payconnect',
    loadChildren: () => import('./payconnect/payconnect.module').then( m => m.PayconnectPageModule)
  },
  {
    path: 'order',
    loadChildren: () => import('./order/order.module').then( m => m.OrderPageModule)
  },
  {
    path: 'favorite',
    loadChildren: () => import('./favorite/favorite.module').then( m => m.FavoritePageModule)
  },
  {
    path: 'orderdetail',
    loadChildren: () => import('./orderdetail/orderdetail.module').then( m => m.OrderdetailPageModule)
  },
  {
    path: 'orderbottom',
    loadChildren: () => import('./orderbottom/orderbottom.module').then( m => m.OrderbottomPageModule)
  },
  {
    path: 'bottomshop',
    loadChildren: () => import('./bottomshop/bottomshop.module').then( m => m.BottomshopPageModule)
  },
  {
    path: 'bottomdriver',
    loadChildren: () => import('./bottomdriver/bottomdriver.module').then( m => m.BottomdriverPageModule)
  },
  {
    path: 'bottomcode',
    loadChildren: () => import('./bottomcode/bottomcode.module').then( m => m.BottomcodePageModule)
  },
  {
    path: 'privacy',
    loadChildren: () => import('./privacy/privacy.module').then( m => m.PrivacyPageModule)
  },
  {
    path: 'bottom-popup-promo',
    loadChildren: () => import('./bottom-popup-promo/bottom-popup-promo.module').then( m => m.BottomPopupPromoPageModule)
  },
  {
    path: 'promotions',
    loadChildren: () => import('./promotions/promotions.module').then( m => m.PromotionsPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
